import { render, staticRenderFns } from "./shenhegoodsDialog.vue?vue&type=template&id=32d042c4"
import script from "./shenhegoodsDialog.vue?vue&type=script&lang=js"
export * from "./shenhegoodsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports